// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__gllwg","header":"PatientQuestionnaire_header__2Iu1g","info":"PatientQuestionnaire_info__F-V8t"};